"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-5a516592"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { class: "ancient-books-layout" };
var _hoisted_2 = { class: "search-box" };
var _hoisted_3 = { class: "search-container" };
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("h4", { class: "layout-title" }, "古籍学习", -1); });
var _hoisted_5 = { class: "search" };
var _hoisted_6 = { class: "content-box scroll-bar" };
var _hoisted_7 = { class: "content-container" };
var _hoisted_8 = { style: { "width": "350px" } };
var _hoisted_9 = ["onClick", "src", "alt"];
var _hoisted_10 = {
    key: 1,
    class: "empty"
};
var vue_3 = require("vue");
var vue_router_1 = require("vue-router");
var element_plus_1 = require("element-plus");
var ancient_poetry_1 = require("@/apis/ancient-poetry");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AncientBooks',
    setup: function (__props) {
        var router = (0, vue_router_1.useRouter)();
        var params = (0, vue_3.ref)({
            page: 1,
            limit: 10,
            title: '',
        });
        var list = (0, vue_3.ref)([]);
        var total = (0, vue_3.ref)(0);
        var isGetMore = (0, vue_3.ref)(true);
        var getAncientBooksList = function () {
            if (total.value > 0 && params.value.page * params.value.limit > 60) {
                element_plus_1.ElMessage.success("古籍数据已全部获取完毕");
                isGetMore.value = false;
                return;
            }
            ancient_poetry_1.ancientBooksApi.getAncientBooksList(params.value).then(function (res) {
                list.value = list.value.concat(res.data.result);
                total.value = res.data.total;
            });
        };
        var handleSearch = function () {
            params.value.page = 1;
            list.value = [];
            getAncientBooksList();
        };
        var loadingMoreData = function () {
            if (!isGetMore.value) {
                return;
            }
            getAncientBooksList();
            params.value.page += 1;
        };
        var goBookDetail = function (id) {
            router.push({ path: '/ancient/poetry/book', query: { id: id, } });
        };
        return function (_ctx, _cache) {
            var _component_el_button = (0, vue_2.resolveComponent)("el-button");
            var _component_el_input = (0, vue_2.resolveComponent)("el-input");
            var _component_el_tooltip = (0, vue_2.resolveComponent)("el-tooltip");
            var _component_el_col = (0, vue_2.resolveComponent)("el-col");
            var _component_el_row = (0, vue_2.resolveComponent)("el-row");
            var _component_el_empty = (0, vue_2.resolveComponent)("el-empty");
            var _directive_infinite_scroll = (0, vue_2.resolveDirective)("infinite-scroll");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        _hoisted_4,
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createVNode)(_component_el_input, {
                                clearable: "",
                                onKeydown: (0, vue_2.withKeys)(handleSearch, ["enter"]),
                                onClear: handleSearch,
                                size: "large",
                                modelValue: (0, vue_2.unref)(params).title,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (((0, vue_2.unref)(params).title) = $event); }),
                                placeholder: "请输入古籍名称"
                            }, {
                                append: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(_component_el_button, {
                                        icon: "Search",
                                        onClick: handleSearch
                                    })
                                ]; }),
                                _: 1
                            }, 8, ["onKeydown", "modelValue"])
                        ])
                    ])
                ]),
                (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                    (Array.isArray((0, vue_2.unref)(list)) && (0, vue_2.unref)(list).length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_row, { key: 0 }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(list), function (item) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_col, {
                                        key: item.id,
                                        span: 6
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                                (0, vue_2.createVNode)(_component_el_tooltip, {
                                                    placement: "right",
                                                    effect: "light"
                                                }, {
                                                    content: (0, vue_2.withCtx)(function () { return [
                                                        (0, vue_2.createElementVNode)("h3", null, " 《" + (0, vue_2.toDisplayString)(item.title) + "》 ", 1),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)(item.introduce), 1)
                                                    ]; }),
                                                    default: (0, vue_2.withCtx)(function () { return [
                                                        (0, vue_2.createElementVNode)("img", {
                                                            onClick: (0, vue_2.withModifiers)(function ($event) { return (goBookDetail(item.id)); }, ["stop"]),
                                                            src: item.pic_url,
                                                            alt: item.title,
                                                            class: "image"
                                                        }, null, 8, _hoisted_9)
                                                    ]; }),
                                                    _: 2
                                                }, 1024)
                                            ])
                                        ]; }),
                                        _: 2
                                    }, 1024));
                                }), 128))
                            ]; }),
                            _: 1
                        }))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                            (0, vue_2.createVNode)(_component_el_empty, { description: "数据为空" })
                        ]))
                ])), [
                    [_directive_infinite_scroll, loadingMoreData]
                ])
            ]));
        };
    }
});
